import React from "react";
import { Table } from "reactstrap";
import { array } from "prop-types";

import ScoreCardRow from "../score-cards-row";

const ScoreCardsTable = ({ cards }) => {
  const rows = cards.map((entry) => (
    <ScoreCardRow key={entry.id} card={entry} />
  ));

  return (
    <Table className="logs-table">
      <thead className="thead-light">
        <tr>
          <th>Name</th>
          <th>Date Created</th>
          <th>Created by</th>
          <th>Type</th>
          <th className="center">Is Valid</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

ScoreCardsTable.propTypes = {
  cards: array,
};

export default ScoreCardsTable;



// WEBPACK FOOTER //
// ./src/features/score-card/components/score-cards-table/ScoreCardsTable.jsx